export default "__VITE_ASSET__C4Neb2sl__"